import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {
};
const getters = {
};
const mutations = {
};

const actions = {

    actPostCheckout: (context, payload) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/cart/checkout', {
                method: 'POST',
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.text()
                }).then((data) => {
                    console.log("data", data)
                    resolve(data)

                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve('{"completed":1,"total":1,"order":{"customerid":"27026088","type":"NEW","planid":"MPnY8Ti1","plandetails":{"idplan":"MPnY8Ti1","planname":"BENGALI STARTER","plantype":"PACKAGE","plancode":"INB0013PP","packagecode":null,"description":"BENGALI STARTER","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","created":"2019-01-30 07:45:36","lcoprice":"73.44","mrptariff":"81.60","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"6.00","servicecode1":null,"renewperiod":"12","hardwaretype":"ALL","numchannels":"42","plancategory":"NORMAL","planid":"MPnY8Ti1","enteredid":"CAN27026088"},"plantype":"PACKAGE","enteredid":"CAN27026088"},"result":{"success":37505469,"planprice":93.74,"customercan":"CAN27026088","validity":"2021-10-06"}}/r/nnull')
                        return
                    }
                    reject(error);
                });
        });
    },

    actRemoveCart: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

            fetch(context.getters.baseUrl + '/lco/v1/cart/remove' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    if (response.ok && response.status == 200) {
                        return response.json()
                    } else if (response.status == 401) {
                        reject({ error: 'Sorry, Your Session has been expired' })
                        setTimeout(() => this.$router.push({ name: '/' }), 3000);
                    } else {
                        reject({ error: 'Getting recently watched error' })
                    }
                }).then((data) => {

                    resolve(data)

                    //type CLK DLK
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    addPackInCart: (context, data) => {
        console.log("before call api", data)
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/cart', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },

    removePackFromCart: (context, data) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(data)
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/cart/remove' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },
    emptyCart: (context) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/cart/delete', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },
    getCartData: (context) => {
        return new Promise((resolve, reject) => {
            let getCartData = JSON.parse(localStorage.getItem('getCartData'))
            if (getCartData) {
                if (Object.keys(getCartData).length) {
                    resolve(getCartData)
                    return
                }
            }
            fetch(context.getters.baseUrl + '/lco/v1/cart', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    localStorage.setItem("getCartData",JSON.stringify(data))
                    resolve(data)

                }).catch((error) => {
                    reject(error)
                });
        });
    },
    addNewInvoice: (context, payload) => {
        return new Promise((resolve, reject) => {
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/invoice', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    }
};
export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/cartSubscribeModule.js